module.exports = __webpack_public_path__ + "static/media/celebrity.14cefe20.jpg";